import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { IncidentsPage } from '@/features/safety/incidents-page';

const searchSchema = z.object({
  incident: z.string().optional().catch(undefined),
  new: z.boolean().optional().catch(undefined),
});

export const Route = createFileRoute('/_app/projects/$projectId/safety/incidents')({
  validateSearch: searchSchema,
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  const search = Route.useSearch();
  return <IncidentsPage projectId={projectId} incidentId={search.incident} create={search.new} />;
}
